module.exports = __webpack_public_path__ + "1342a067342c557bba3be8cdcac1108c.woff";